import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-e1-parts",
  "use": "icon-leo-e1-parts-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-e1-parts\">\r\n<g transform=\"translate(-183.182 -63.716) scale(1.137778)\">\r\n<path d=\"M448 192h128v80l56 32 56-32 90 90-32 56 32 56-80 48v112l80 48-32 56 32 56-90 90-56-32-56 32H448l-56-32-56 32-90-90 32-56-32-56 80-48V522l-80-48 32-56-32-56 90-90 56 32 56-32V192zm64 192c-71 0-128 57-128 128s57 128 128 128 128-57 128-128-57-128-128-128zm0 80a48 48 0 1 1 0 96 48 48 0 0 1 0-96z\" />\r\n  <path d=\"M736 128h96v48l40 24 40-24 64 64-24 40 24 40-48 32v72l48 32-24 40 24 40-64 64-40-24-40 24h-96l-40-24-40 24-64-64 24-40-24-40 48-32v-72l-48-32 24-40-24-40 64-64 40 24 40-24V128zm48 112c-40 0-72 32-72 72s32 72 72 72 72-32 72-72-32-72-72-72z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-e1-parts.svg
// module id = /XZh
// module chunks = 546